// src/view/admin/did/components/DIDTable.jsx

import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
  Chip,
  Stack,
  Typography,
  Tooltip,
  alpha,
} from "@mui/material";

import {
  Pencil,
  Trash2,
  Globe,
  CheckCircle,
  XCircle,
  Filter as FilterIcon,
  ChevronUp,
  ChevronDown,
} from "lucide-react";

export const DIDTable = ({ data, sortConfig, onSort, onEdit, onDelete }) => {
  const role = localStorage.getItem("role");
  const SortHeader = ({ label, sortKey }) => (
    <TableCell
      onClick={() => sortKey && onSort(sortKey)}
      sx={{
        cursor: sortKey ? "pointer" : "default",
        bgcolor: "#f8fafc",
        fontWeight: 700,
        textTransform: "uppercase",
        fontSize: 12,
      }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        {label}
        {sortConfig.key === sortKey &&
          (sortConfig.direction === "asc" ? (
            <ChevronUp size={14} />
          ) : (
            <ChevronDown size={14} />
          ))}
      </Stack>
    </TableCell>
  );

  if (data.length === 0)
    return (
      <Paper sx={{ p: 6, textAlign: "center", borderRadius: 3 }}>
        <FilterIcon size={40} />
        <Typography>No DIDs Found</Typography>
      </Paper>
    );

  return (
    <Paper sx={{ borderRadius: 3, border: "1px solid #e5e7eb" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <SortHeader label="#" />
              <SortHeader label="DID Number" sortKey="did_alias" />
              <SortHeader label="Country" sortKey="country" />
              <SortHeader label="Status" />
              <SortHeader label="Company Nmae" />
              <SortHeader label="Actions" />
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((did, index) => {
              const isAvailable =
                (did.did_isAvailable || "").toLowerCase() === "yes";

              return (
                <TableRow key={did._id || index} hover>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Typography fontFamily="monospace" fontWeight={600}>
                      {did.did_alias}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={did.country}
                      size="small"
                      sx={{
                        bgcolor: alpha("#ffffffff", 0.1),
                        color: did.country == "IND" ? "blue" : "orangered",
                        borderRadius: 1.5,
                        fontWeight: 650,
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <Chip
                      icon={
                        isAvailable ? (
                          <CheckCircle size={14} />
                        ) : (
                          <XCircle size={14} />
                        )
                      }
                      label={isAvailable ? "Available" : "Unavailable"}
                      size="small"
                      sx={{
                        borderRadius: 1.5,
                        fontSize: 12,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        bgcolor: isAvailable
                          ? "rgba(34, 197, 94, 0.15)"
                          : "rgba(100, 116, 139, 0.15)",
                        color: isAvailable ? "#166534" : "#475569",
                        border: `1px solid ${
                          isAvailable
                            ? "rgba(255, 255, 255, 0.3)"
                            : "rgba(100, 116, 139, 0.3)"
                        }`,
                      }}
                    />
                  </TableCell>

                  <TableCell>{did.companyName || "-"}</TableCell>

                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      {role === "admin" || role === "superadmin" ? (
                        <Tooltip title="Edit">
                          <IconButton onClick={() => onEdit(did)}>
                            <Pencil size={16} />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="permission denied">
                          <IconButton disabled>
                            <Pencil size={16} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Stack>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
